import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min.js";
import "./assets/css/general.css";
import "./App.css";
import { useState, useEffect, createContext, useRef } from "react";
import {
  localStorageManagerReturn,
  checkLogin,
} from "./global/GlobalFunctions";
import axios from "axios";
import Cookies from "js-cookie";
import { getFilterArbitragem } from "./components/functions/FunctionsFilter";
import { Routes, Route, useLocation, useNavigate } from "react-router-dom";

import { FilterHead } from "./hooks/FilterHead";
import { decrypt_game } from "./components/functions/FunctionsGames";
import {
  URL_SAFE_BET,
  URL_DADOSPRE,
} from "./components/variables/VariablesGame";
import LZString from "lz-string";

import { initMercadoPago } from "@mercadopago/sdk-react";
import "./assets/css/dashboard.css";
import { bonusAllowedRoles } from "./global/GlobalVariables";

import HomePage from "./pages/HomePage";
import TermsPage from "./pages/TermsPage";
import PaymentPage from "./pages/PaymentPage";
import PaymentApprovedPage from "./pages/PaymentApprovedPage";
import PlanPage from "./pages/PlanPage";
import RenewPasswordPage from "./pages/RenewPasswordPage";
import BonusListPage from "./pages/BonusListPage";
import BonusCalculatorPage from "./pages/BonusCalculatorPage";
import BonusCalculatorEditPage from "./pages/BonusCalculatorEditPage";
import BonusCalculatorCreatorPage from "./pages/BonusCalculatorCreatorPage";
import AffiliatePage from "./pages/AffiliatePage";
import CoursePage from "./pages/CoursePage";
import AboutPage from "./pages/AboutPage";
import CalculatorEmptyPage from "./pages/CalculatorEmptyPage";
import CalculatorPage from "./pages/CalculatorPage";
import ExtensionPage from "./pages/ExtensionPage";
import DashboardPage from "./pages/DashboardPage";
import DashboardUsersPage from "./pages/DashboardUsersPage";
import EditUserPage from "./pages/EditUserPage";
import ConfigPage from "./pages/ConfigPage";
import GenerateLinkPage from "./pages/GenerateLinkPage";
import RenewalPage from "./pages/RenewalPage";
import Spreadsheet from "./pages/Spreadsheet";
import ExtensionBrowser from "./params-urls-manager/ExtensionBrowser";
import PageNotFound from "./pages/PageNotFound";
import PageGlobalPlan from "./pages/GlobalPlan";
export const Context = createContext();

initMercadoPago("APP_USR-01e92b7d-7a5c-4a66-97a9-1f94dad8025a", {
  locale: "pt-BR",
});

function App() {
  const location = useLocation();
  const [userPlan, setUserPlan] = useState("free");
  const [popupWindow, setPopupWindow] = useState(null);
  const [popuwindowsBet, setPopupWindowBet] = useState(null);
  const [filterOrder, setFilterOrder] = useState(
    localStorageManagerReturn("classificationSurebet", "lucro"),
  );

  const [canOpenCalculator, setCanOpenCalculator] = useState(false);

  const controllerLocalStorage = FilterHead();
  controllerLocalStorage["readLocalstorage"]();
  const [userData, setUserData] = useState(
    JSON.parse(localStorage["userData"]),
  );

  const [entradasLigth, setentradasLigth] = useState(
    JSON.parse(localStorage["entradaslight"]),
  );
  const [entradasPro, setentradasPro] = useState(
    JSON.parse(localStorage["entradaspro"]),
  );

  const [entradasGlobal, setEntradasGlobal] = useState(
    localStorage["entradasGlobal"] === "true" ? true : false,
  );

  const clearOldSurebet = useRef(false);

  const [DateMsg, setDateMsg] = useState(
    JSON.parse(localStorage["preferenceData"]),
  );

  const [valueMin, setValueMin] = useState(
    JSON.parse(localStorage["profitMin"]),
  );
  const [valueMax, setValueMax] = useState(
    JSON.parse(localStorage["profitMax"]),
  );
  const [betHome, setBetHome] = useState(
    JSON.parse(localStorage["listBehomeEnabled"]),
  );
  const [sports, setSports] = useState(
    JSON.parse(localStorage["listSportsEnabled"]),
  );
  const [quantitySportsEnabled, setQuantitySportsEnabled] = useState(
    JSON.parse(localStorage["listSportsEnabled"]).length,
  );
  const [quantityBetHomeEnabled, setQuantityBetHomeEnabled] = useState(
    JSON.parse(localStorage["listBehomeEnabled"]).length,
  );
  const [AparecerProf, setAparecerProf] = useState(false);
  const [AparecerVivo, setAparecerVivo] = useState(false);
  const [AparecerLight, setAparecerLight] = useState(false);
  const [AparecerPro, setAparecerPro] = useState(false);

  const [timeEvent, setTimeEvent] = useState(null);
  const [itemsTrash, setItemsTrash] = useState(
    JSON.parse(localStorage["trash"]),
  );
  const [statusMode, setStatusMode] = useState(
    JSON.parse(localStorage["statusMode"]),
  );
  const [login, setLogin] = useState(false);
  const showLogoutButton = location.pathname === "/";

  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [listBehomeEnableds, setlistBehomeEnableds] = useState(
    JSON.parse(localStorage["listBehomeEnabled"]),
  );
  const [notificationVolume, setNotificationVolume] = useState(null);
  const [marketsUnselected, setMarketsUnselected] = useState([]);
  const [blacklistWords, setBlacklistWords] = useState([]);
  const accountFeatures = useRef([]);

  const [Idinitialization, setIdinitialization] = useState(
    JSON.parse(localStorage["Idinitialization"]),
  );
  const [Amountinitialization, setAmountinitialization] = useState(
    JSON.parse(localStorage["Amountinitialization"]),
  );
  const [requiredBetHome, setRequiredBetHome] = useState([]);

  const [canCheckLogin, setCanCheckLogin] = useState(false);
  const skipAutoLogin = useRef(false);
  const [showHomeScreen, setShowHomeScreen] = useState(false);

  const [canGetOperation, setCanGetOperation] = useState(true);

  const plansType = useRef("");

  const handleLoginSuccess = async (isLoggedIn, userData) => {
    updateUserPreferences(userData);
  };

  const FectDataC = async () => {
    if (localStorage.getItem("dataCalculator") === null) {
      const b4726486 = Cookies.get("b4726486");

      if (b4726486 === undefined) {
        return undefined;
      }

      const response = await axios.post(
        URL_SAFE_BET,
        {
          b652242: b4726486,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        },
      );
      if (response.status !== 200) throw new Error("Falha na requisição");

      let oldDataJsonConvertted;
      try {
        oldDataJsonConvertted = decrypt_game(response.data);
      } catch (error) {
        console.error("Erro ao analisar response.data:", error);
        oldDataJsonConvertted = {};
      }

      const responses = await axios.post(
        URL_DADOSPRE,
        {
          b652242: b4726486,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        },
      );
      if (responses.status !== 200) throw new Error("Falha na requisição");

      const oldDataJsonConvertted_pre = responses.data;

      let valueObjectcombinado = {
        ...oldDataJsonConvertted,
        ...oldDataJsonConvertted_pre,
      };

      const compressed = LZString.compress(
        JSON.stringify(valueObjectcombinado),
      );

      localStorage.setItem("dataCalculator", compressed);
      setTimeout(() => {
        setCanOpenCalculator(true);
      }, 1000);
    } else {
      setTimeout(() => {
        setCanOpenCalculator(true);
      }, 100);
    }
  };

  function hasUserLoggedData() {
    let getUserDataSaved = localStorage.getItem("userData");
    if (getUserDataSaved !== null) {
      let userDataSaved = JSON.parse(getUserDataSaved);

      if (
        userDataSaved["sessionID"] !== undefined &&
        userDataSaved["sessionID"].length > 0
      ) {
        return true;
      }
    }
    return false;
  }

  useEffect(() => {
    if (userData === null) {
      setIsLoggedIn(false);
      setLogin(false);
      window.localStorage.setItem("login", JSON.stringify(false));
    }
    if (isLoggedIn && !location.pathname.startsWith("/payament/")) {
      const dados = JSON.parse(localStorage.getItem("userData"));

      handleLoginSuccess(isLoggedIn, dados);
    }
    let canGetCalculatorData = hasUserLoggedData();

    if (canGetCalculatorData === true) {
      FectDataC();
    }
    const FectDataCInterval = setTimeout(() => {
      canGetCalculatorData = hasUserLoggedData();
      if (canGetCalculatorData === true) {
        FectDataC();
      }
    }, 5000);

    let marketsUnselectedLocalStorage =
      localStorage.getItem("marketsUnselected");
    let blacklistWordsLocalStorage = localStorage.getItem("blacklistWords");

    if (
      marketsUnselectedLocalStorage !== null &&
      marketsUnselectedLocalStorage !== undefined
    ) {
      let marketsUnselected = JSON.parse(marketsUnselectedLocalStorage);
      setMarketsUnselected(marketsUnselected);
    }

    if (
      blacklistWordsLocalStorage !== null &&
      blacklistWordsLocalStorage !== undefined
    ) {
      let blacklistWordsStorage = JSON.parse(blacklistWordsLocalStorage);
      setBlacklistWords(blacklistWordsStorage);
    }

    return () => clearInterval(FectDataCInterval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const navigate = useNavigate();
  useEffect(() => {
    if (userData !== null && "tipo_de_plano" in userData) {
      const namePlanLower = userData.tipo_de_plano.toLowerCase();
      plansType.current = namePlanLower;
    }
  }, [userData]);

  function startCheckLogin() {
    let hasSomeoneLogged = hasUserLoggedData();
    if (hasSomeoneLogged === true) {
      let getUserDataSaved = localStorage.getItem("userData");
      let userDataSaved = JSON.parse(getUserDataSaved);

      setIsLoggedIn(true);
      setLogin(true);
      updateUserPreferences(userDataSaved);
      setShowHomeScreen(true);
    } else {
      setShowHomeScreen(true);

      if (
        location.pathname.includes("bonus/calculator") === true &&
        location.pathname.slice(-4) === "edit"
      ) {
        navigate("/");
      } else if (
        location.pathname.includes("bonus/list") === true ||
        location.pathname.includes("bonus/creator/calculator") === true
      ) {
        navigate("/");
      }
    }
  }

  useEffect(() => {
    startCheckLogin();

    let requiredBetHomeSave = localStorageManagerReturn("riquiredsBethome", []);
    if (Array.isArray(requiredBetHomeSave) === true) {
      setRequiredBetHome(requiredBetHomeSave);
    }

    statusMode
      ? (document.body.style.backgroundColor = "#0d0d0d")
      : (document.body.style.backgroundColor = "");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const setAndGetUserData = (responses) => {
    window.localStorage.setItem("userData", JSON.stringify(responses.data));
    window.localStorage.setItem("statusMode", JSON.stringify(statusMode));
    let host = window.location.hostname;
    let domainWebsite = host.split(".").slice(-2).join(".");
    Cookies.set("b4726486", responses.data.sessionID, {
      expires: 365,
      domain: domainWebsite,
    });

    let accountFeaturesReceived = JSON.parse(responses.data.account_features);
    accountFeatures.current = accountFeaturesReceived;

    getFilterArbitragem(
      accountFeaturesReceived,
      setBetHome,
      setSports,
      setFilterOrder,
      setTimeEvent,
      setValueMin,
      setValueMax,
      setQuantityBetHomeEnabled,
      setQuantitySportsEnabled,
      setMarketsUnselected,
      setBlacklistWords,
    );

    if ("tipo_de_plano" in responses.data) {
      const namePlanLower = responses.data.tipo_de_plano.toLowerCase();
      plansType.current = namePlanLower;
    }

    setUserData(responses.data);
    setUserPlan(responses.data.plano);

    setCanCheckLogin(true);
    setIsLoggedIn(true);
    setLogin(true);

    let userPlanLower = responses.data.plano.toLowerCase();

    let pathnameLower = location.pathname.toLocaleLowerCase();

    let hasPlan = JSON.parse(localStorage.hasPlan);

    if (location.pathname.includes("/plano-global") === true) {
      //Campo vazio para evitar redirecionamento
    } else if (
      (userPlanLower === "free" || userPlanLower === "gratuito") &&
      pathnameLower.includes("/payament/") === false &&
      pathnameLower.includes("/payment-approved") === false
    ) {
      navigate("/plano");
    } else if (location.pathname.toLocaleLowerCase() == "/plano") {
      navigate("/renovacao");
    }

    if (hasPlan === false && accountFeaturesReceived.length > 0) {
      localStorage.setItem("hasPlan", JSON.stringify(true));

      let hasLightMode = accountFeaturesReceived.includes("light");
      let hasProMode = accountFeaturesReceived.includes("pro");
      let hasGlobalMode = accountFeaturesReceived.includes("global");

      localStorage.setItem("entradaslight", JSON.stringify(hasLightMode));
      localStorage.setItem("entradaspro", JSON.stringify(hasProMode));
      localStorage.setItem(
        "threeHouseEntryisActivated",
        JSON.stringify(hasProMode),
      );

      setentradasLigth(hasLightMode);
      setentradasPro(hasProMode);
      setEntradasGlobal(hasGlobalMode);
    } else if (
      accountFeaturesReceived.length === 1 &&
      accountFeaturesReceived.includes("light") === true
    ) {
      localStorage.setItem("entradaslight", JSON.stringify(true));
      setentradasLigth(true);
    } else if (accountFeaturesReceived.length === 0) {
      localStorage.setItem("hasPlan", JSON.stringify(false));

      localStorage.setItem("entradaslight", JSON.stringify(false));
      localStorage.setItem("entradaspro", JSON.stringify(false));
      localStorage.setItem("entradasGlobal", JSON.stringify(false));

      setentradasLigth(false);
      setentradasPro(false);
      setEntradasGlobal(false);
    }
  };

  const updateUserPreferences = async (userData) => {
    try {
      let responses = {};
      responses["data"] = userData;
      if (skipAutoLogin.current === false) {
        checkLogin().then((data) => {
          if (
            data["user_data"] !== undefined &&
            data["user_data"] !== null &&
            typeof data["user_data"] === "object"
          ) {
            responses["data"] = data["user_data"];
            setAndGetUserData(responses);
          } else {
            localStorage.clear();
            Cookies.remove("b4726486");
          }
        });
      } else {
        setAndGetUserData(responses);
      }

      return true;
    } catch (error) {
      console.error("Erro ao enviar dados:", error);
      return false;
    }
  };

  useEffect(() => {
    let hasSomeoneLogged = hasUserLoggedData();

    if (location.pathname.includes("/plano-global") === true) {
      //Campo vazio para evitar redirecionamento
    } else if (location.pathname === "/extensao") {
      if (hasSomeoneLogged === false) {
        navigate("/");
      }
    } else if (
      (location.pathname === "/dashboard/users" ||
        location.pathname === "/dashboard") &&
      (canCheckLogin === true || hasSomeoneLogged === false)
    ) {
      if (userData.username !== "admin" || hasSomeoneLogged === false) {
        navigate("/");
      }
    } else if (
      hasSomeoneLogged === false &&
      location.pathname === "/payment-approved"
    ) {
      navigate("/");
    } else if (
      location.pathname.includes("bonus/list") === true &&
      canCheckLogin == true
    ) {
      if (
        bonusAllowedRoles.includes(userData.username) === false ||
        !!userData.username === false
      ) {
        navigate("/");
      }
    }
    if (location.pathname.includes("/planilha") === true) {
      window.location.reload();
    }

    if (
      location.pathname.includes("bonus/creator/calculator") === true &&
      canCheckLogin == true
    ) {
      if (
        bonusAllowedRoles.includes(userData.username) === false ||
        !!userData.username === false
      ) {
        navigate("/");
      }
    } else if (
      location.pathname.includes("bonus/calculator") === true &&
      isLoggedIn === true &&
      canCheckLogin == true &&
      location.pathname.slice(-4) === "edit"
    ) {
      if (
        bonusAllowedRoles.includes(userData.username) === false ||
        !!userData.username === false
      ) {
        navigate("/");
      }
    } else if (
      hasSomeoneLogged === true &&
      location.pathname.includes("/renew-password") === true
    ) {
      navigate("/");
    }
  }, [location, canCheckLogin]);

  return (
    <div className="App">
      <Routes>
        <Route
          path="/nav/arb/prong/0/abcdefg/if"
          element={<ExtensionBrowser />}
        />

        <Route
          path="/payament/:plan_name"
          element={
            <PaymentPage
              statusMode={statusMode}
              setStatusMode={setStatusMode}
              isLoggedIn={isLoggedIn}
              showLogoutButton={showLogoutButton}
            />
          }
        />

        <Route path="/planilha" element={<Spreadsheet />} />

        <Route path="/termoscondicoes" element={<TermsPage />} />

        <Route
          path="/payment-approved"
          element={
            canCheckLogin === true ? (
              <PaymentApprovedPage
                userPlan={userPlan}
                isLoggedIn={isLoggedIn}
                statusMode={statusMode}
                setStatusMode={setStatusMode}
                showLogoutButton={showLogoutButton}
                notificationVolume={notificationVolume}
                setNotificationVolume={setNotificationVolume}
                userData={userData}
              />
            ) : (
              ""
            )
          }
        />

        <Route
          path="/plano"
          element={
            <PageGlobalPlan
            statusMode={statusMode}
              setStatusMode={setStatusMode}
              isLoggedIn={isLoggedIn}
              showLogoutButton={showLogoutButton}
              notificationVolume={notificationVolume}
              setNotificationVolume={setNotificationVolume}
              userData={userData}
              setIdinitialization={setIdinitialization}
              setAmountinitialization={setAmountinitialization}
              Idinitialization={Idinitialization}
              DateMsg={DateMsg}
              setDateMsg={setDateMsg}
              headerPaid={false}
            />
          }
        />

        <Route
          path="/"
          element={
            <HomePage
              showHomeScreen={showHomeScreen}
              login={login}
              accountFeatures={accountFeatures}
              userData={userData}
              setAndGetUserData={setAndGetUserData}
              setentradasLigth={setentradasLigth}
              entradasLigth={entradasLigth}
              setentradasPro={setentradasPro}
              entradasPro={entradasPro}
              statusMode={statusMode}
              setStatusMode={setStatusMode}
              isLoggedIn={isLoggedIn}
              showLogoutButton={showLogoutButton}
              notificationVolume={notificationVolume}
              setNotificationVolume={setNotificationVolume}
              valueMin={valueMin}
              setValueMin={setValueMin}
              valueMax={valueMax}
              setValueMax={setValueMax}
              betHome={betHome}
              setBetHome={setBetHome}
              sports={sports}
              setSports={setSports}
              timeEvent={timeEvent}
              setTimeEvent={setTimeEvent}
              itemsTrash={itemsTrash}
              setItemsTrash={setItemsTrash}
              controllerLocalStorage={controllerLocalStorage}
              quantityBetHomeEnabled={quantityBetHomeEnabled}
              setQuantityBetHomeEnabled={setQuantityBetHomeEnabled}
              quantitySportsEnabled={quantitySportsEnabled}
              setQuantitySportsEnabled={setQuantitySportsEnabled}
              setlistBehomeEnableds={setlistBehomeEnableds}
              AparecerProf={AparecerProf}
              setAparecerProf={setAparecerProf}
              AparecerVivo={AparecerVivo}
              setAparecerVivo={setAparecerVivo}
              AparecerLight={AparecerLight}
              setAparecerLight={setAparecerLight}
              AparecerPro={AparecerPro}
              setAparecerPro={setAparecerPro}
              filterOrder={filterOrder}
              setFilterOrder={setFilterOrder}
              requiredBetHome={requiredBetHome}
              setRequiredBetHome={setRequiredBetHome}
              marketsUnselected={marketsUnselected}
              setMarketsUnselected={setMarketsUnselected}
              clearOldSurebet={clearOldSurebet}
              blacklistWords={blacklistWords}
              setBlacklistWords={setBlacklistWords}
              popupWindow={popupWindow}
              setPopupWindow={setPopupWindow}
              popuwindowsBet={popuwindowsBet}
              setPopupWindowBet={setPopupWindowBet}
              canGetOperation={canGetOperation}
              setCanGetOperation={setCanGetOperation}
              entradasGlobal={entradasGlobal}
              setEntradasGlobal={setEntradasGlobal}
            />
          }
        />

        <Route path="/renew-password" element={<RenewPasswordPage />} />

        <Route
          path="/bonus/list"
          element={
            canCheckLogin === true &&
            !!userData.username === true &&
            bonusAllowedRoles.includes(userData.username) === true ? (
              <BonusListPage
                statusMode={statusMode}
                setStatusMode={setStatusMode}
              />
            ) : (
              ""
            )
          }
        />

        <Route
          path="/bonus/calculator/:id"
          element={
            <BonusCalculatorPage
              statusMode={statusMode}
              setStatusMode={setStatusMode}
              userData={userData}
            />
          }
        />

        <Route
          path="/bonus/calculator/:id/edit"
          element={
            canCheckLogin === true &&
            !!userData.username === true &&
            bonusAllowedRoles.includes(userData.username) === true ? (
              <BonusCalculatorEditPage
                statusMode={statusMode}
                setStatusMode={setStatusMode}
              />
            ) : (
              ""
            )
          }
        />

        <Route
          path="/bonus/creator/calculator"
          element={
            canCheckLogin === true &&
            !!userData.username === true &&
            bonusAllowedRoles.includes(userData.username) === true ? (
              <BonusCalculatorCreatorPage
                statusMode={statusMode}
                setStatusMode={setStatusMode}
              />
            ) : (
              ""
            )
          }
        />

        <Route
          path="/afiliado"
          element={
            <AffiliatePage
              statusMode={statusMode}
              setStatusMode={setStatusMode}
              isLoggedIn={isLoggedIn}
              showLogoutButton={showLogoutButton}
              notificationVolume={notificationVolume}
              setNotificationVolume={setNotificationVolume}
              userData={userData}
            />
          }
        />
        <Route
          path="/curso"
          element={
            <CoursePage
              statusMode={statusMode}
              setStatusMode={setStatusMode}
              isLoggedIn={isLoggedIn}
              showLogoutButton={showLogoutButton}
              notificationVolume={notificationVolume}
              setNotificationVolume={setNotificationVolume}
              userData={userData}
            />
          }
        />
        <Route
          path="/quesomos"
          element={
            <AboutPage
              statusMode={statusMode}
              setStatusMode={setStatusMode}
              isLoggedIn={isLoggedIn}
              showLogoutButton={showLogoutButton}
              notificationVolume={notificationVolume}
              setNotificationVolume={setNotificationVolume}
              userData={userData}
            />
          }
        />

        <Route
          path="/calculator"
          element={
            <CalculatorEmptyPage
              statusMode={statusMode}
              setStatusMode={setStatusMode}
              isLoggedIn={isLoggedIn}
              showLogoutButton={showLogoutButton}
            />
          }
        />

        <Route
          path="/calculator/:id"
          element={
            <CalculatorPage
              canOpenCalculator={canOpenCalculator}
              statusMode={statusMode}
              setStatusMode={setStatusMode}
              isLoggedIn={isLoggedIn}
              showLogoutButton={showLogoutButton}
              userData={userData}
            />
          }
        />

        <Route
          path="/calculator/:id/:id2"
          element={
            <CalculatorPage
              canOpenCalculator={canOpenCalculator}
              statusMode={statusMode}
              setStatusMode={setStatusMode}
              isLoggedIn={isLoggedIn}
              showLogoutButton={showLogoutButton}
              userData={userData}
            />
          }
        />

        <Route
          path="/extensao"
          element={
            isLoggedIn === true ? (
              <ExtensionPage
                statusMode={statusMode}
                setStatusMode={setStatusMode}
                isLoggedIn={isLoggedIn}
                showLogoutButton={showLogoutButton}
                notificationVolume={notificationVolume}
                setNotificationVolume={setNotificationVolume}
                userData={userData}
              />
            ) : (
              ""
            )
          }
        />

        <Route
          path="/dashboard"
          element={
            <DashboardPage
              statusMode={statusMode}
              setStatusMode={setStatusMode}
              isLoggedIn={isLoggedIn}
              showLogoutButton={showLogoutButton}
              notificationVolume={notificationVolume}
              setNotificationVolume={setNotificationVolume}
              userData={userData}
            />
          }
        />

        <Route
          path="/dashboard/users"
          element={
            <DashboardUsersPage
              statusMode={statusMode}
              setStatusMode={setStatusMode}
              isLoggedIn={isLoggedIn}
              showLogoutButton={showLogoutButton}
              notificationVolume={notificationVolume}
              setNotificationVolume={setNotificationVolume}
              userData={userData}
            />
          }
        />

        <Route
          path="/user/:id"
          element={
            <EditUserPage
              statusMode={statusMode}
              setStatusMode={setStatusMode}
              isLoggedIn={isLoggedIn}
              showLogoutButton={showLogoutButton}
              notificationVolume={notificationVolume}
              setNotificationVolume={setNotificationVolume}
              userData={userData}
            />
          }
        />

        <Route
          path="/config"
          element={
            <ConfigPage
              statusMode={statusMode}
              setStatusMode={setStatusMode}
              isLoggedIn={isLoggedIn}
              showLogoutButton={showLogoutButton}
              notificationVolume={notificationVolume}
              setNotificationVolume={setNotificationVolume}
              userData={userData}
              valueMin={valueMin}
              valueMax={valueMax}
              betHome={betHome}
              sports={sports}
              timeEvent={timeEvent}
              itemsTrash={itemsTrash}
              setItemsTrash={setItemsTrash}
              controllerLocalStorage={controllerLocalStorage}
              setValueMin={setValueMin}
              setValueMax={setValueMax}
              setBetHome={setBetHome}
              quantityBetHomeEnabled={quantityBetHomeEnabled}
              setQuantityBetHomeEnabled={setQuantityBetHomeEnabled}
              setSports={setSports}
              quantitySportsEnabled={quantitySportsEnabled}
              setQuantitySportsEnabled={setQuantitySportsEnabled}
              setTimeEvent={setTimeEvent}
              setIsLoggedIn={setIsLoggedIn}
              setPopupWindow={setPopupWindow}
              popupWindow={popupWindow}
              setPopupWindowBet={setPopupWindowBet}
              popuwindowsBet={popuwindowsBet}
              setIdinitialization={setIdinitialization}
              setAmountinitialization={setAmountinitialization}
              Idinitialization={Idinitialization}
              setUserData={setUserData}
            />
          }
        />

        <Route
          path="/gerarlink"
          element={
            <GenerateLinkPage
              statusMode={statusMode}
              setStatusMode={setStatusMode}
              isLoggedIn={isLoggedIn}
              showLogoutButton={showLogoutButton}
              notificationVolume={notificationVolume}
              setNotificationVolume={setNotificationVolume}
              userData={userData}
            />
          }
        />
        <Route
          path="/cursos"
          element={
            <CoursePage
              statusMode={statusMode}
              setStatusMode={setStatusMode}
              isLoggedIn={isLoggedIn}
              showLogoutButton={showLogoutButton}
              notificationVolume={notificationVolume}
              setNotificationVolume={setNotificationVolume}
              userData={userData}
            />
          }
        />

        <Route
          path="/renovacao"
          element={
            <PageGlobalPlan
            statusMode={statusMode}
              setStatusMode={setStatusMode}
              isLoggedIn={isLoggedIn}
              showLogoutButton={showLogoutButton}
              notificationVolume={notificationVolume}
              setNotificationVolume={setNotificationVolume}
              userData={userData}
              setIdinitialization={setIdinitialization}
              setAmountinitialization={setAmountinitialization}
              Idinitialization={Idinitialization}
              DateMsg={DateMsg}
              setDateMsg={setDateMsg}
              headerPaid={true}
            />
          }
        />

        

        <Route
          path="*"
          element={
            <PageNotFound
              showHomeScreen={showHomeScreen}
              login={login}
              userData={userData}
              statusMode={statusMode}
              setStatusMode={setStatusMode}
              isLoggedIn={isLoggedIn}
              showLogoutButton={showLogoutButton}
              notificationVolume={notificationVolume}
              setNotificationVolume={setNotificationVolume}
            />
          }
        />
      </Routes>
    </div>
  );
}

export default App;
